import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { saveFailedReason } from "../../services/exam/exam.service";
import { APIStatus } from "../../constants";

export const FailPage: React.FunctionComponent = () => {
	const stateLocation = useLocation();
	const reasonSaveCompleted = useAppSelector((state) => state.exam.reasonSaveCompleted);
	const dispatch = useAppDispatch();
	const { reason, studentId } = stateLocation.state || {};

	console.log("FailPage reason:", reason);
	useEffect(() => {
		handleSaveFailedReason();
		localStorage.removeItem("isReloaded");
		localStorage.removeItem("isBackNavigate");
	}, []);

	useEffect(() => {
		if (reasonSaveCompleted === APIStatus.FULFILLED) {
			localStorage.clear();
			sessionStorage.clear();
		}
	}, [reasonSaveCompleted]);

	const handleSaveFailedReason = (): void => {
		const payload = {
			studentId: studentId,
			reason: reason,
		};
		dispatch(saveFailedReason(payload));
	};
	return (
		<div className="student_module_overview_bg_container main_outer_bg">
			<div className="student_module_overview_content_box overview_inner_bg">
				<div className="overview_content_box_content d-flex flex-column align-items-center justify-content-center h-100">
					<div className="heading_text mb-2">Exam Failed !</div>
					<div className="sub_text mb-3">
						A fair assessment might have been disrupted due to
						{` ${reason ? reason : "opening extra tabs, reloading, or navigating back"}`} during exams.
					</div>
					<div className="logo_container">
						<img className="logo_img" src="/images/logo.png" />
					</div>
					<div className="sub_text font_15">www.simplogics.com</div>
				</div>
			</div>
		</div>
	);
};
